import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import MerchantListItem from "../components/merchantListItem";

import * as actions from "../actions";
import pagination from "../../pagination";

const { Pagination } = pagination;

class MerchantListViewContainer extends Component {
  constructor(props) {
    super(props);
    this.fetchPage = this.fetchPage.bind(this);
    this.cachedImpersonation = {};
  }

  view(merchant, e) {
    e.preventDefault();
    this.props.dispatch(actions.getMerchantDetails(merchant.id));
    this.props.dispatch(actions.getUsersForMerchant(this.props.endpoints.apiHost, merchant.id));
    this.props.router.push("/merchant/" + merchant.id);
  }

  fetchPage() {
    this.props.dispatch(
      actions.getMerchants(
        this.props.endpoints.apiHost,
        this.props.location.query.offset,
        this.props.location.query.limit,
        this.props.location.query.searchParam
      )
    );
  }

  filterResults(impersonation) {
    const searchParam = impersonation.searchParam;
    const originParams = new URLSearchParams(impersonation.origin);
    const originSearchParam = originParams.get("search_param");

    if (searchParam.length === 0) {
      impersonation.merchants = null;
      impersonation.total = 0;
    } else if (searchParam !== originSearchParam) {
      return this.cachedImpersonation;
    }

    this.cachedImpersonation = impersonation;
    return impersonation;
  }

  render() {
    const impersonation = this.filterResults(this.props.impersonation);
    const merchants = impersonation.merchants;

    return (
      <div>
        <div className="merchant-list">
          {merchants && merchants.length ? (
            <div className="table table-highlight merchants-table">
              <div className="table-row table-head">
                <div className="table-cell" width="70%">
                  Name
                </div>
                <div className="table-cell" width="30%">
                  Org Number
                </div>
              </div>
              {merchants.map((merchant) => {
                return <MerchantListItem merchant={merchant} key={merchant.id} />;
              })}
            </div>
          ) : null}
          {merchants && merchants.length == 0 && (
            <p className="help-text">Sorry! Could not find any merchants matching your search...</p>
          )}
        </div>
        <Pagination
          total={impersonation.total}
          pathname={this.props.location.pathname}
          fetchPage={() => this.fetchPage()}
          query={this.props.location.query}
          searchParam={impersonation.searchParam}
          isFetching={impersonation.isFetching}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    endpoints: state.getIn(["config", "endpoints"]),
    impersonation: state.get("impersonation").toJS(),
  };
};

export default withRouter(connect(mapStateToProps)(MerchantListViewContainer));
